import React from 'react';
import { Col } from 'react-bootstrap';
import { FacilityIconDetailed } from '../../../../../img/findcare/FindCareSVG';
import { t } from 'i18next';
const noDataMessage = t('find_provider.data_not_available');
const LeftSection = ({ facilityDetails }) => {
  return (
    <Col sm={3}>
      <div className="secondary-background profile-section d-flex d-md-block">
        <div className="profile-image text-center">
          <FacilityIconDetailed
            circleClassName="provider-details-profile-circle"
            className="provider-details-profile-image"
          />
        </div>
        <div className="other-info ml-4 ml-md-0">
          <p className="age-gender paragraph-font primary-text">
            <b>{t('find_provider.facility_type')}</b> :
            {facilityDetails.FacilityType &&
            facilityDetails.FacilityType != null
              ? ` ${facilityDetails.FacilityType}`
              : ` ${noDataMessage}`}
          </p>
          <p className="paragraph-font primary-text">
            <b>{t('find_provider.email')}</b> <br />
            {facilityDetails.EmailAddress ? (
              <a
                className="secondary-2"
                href={`mailto:${facilityDetails.EmailAddress}`}
              >
                {facilityDetails.EmailAddress}
              </a>
            ) : (
              noDataMessage
            )}
          </p>
          <p className="paragraph-font primary-text">
            <b>{t('find_provider.website')}</b> <br />
            {facilityDetails.Website && facilityDetails.Website != null ? (
              <a
                className="secondary-2 text-break"
                target={'_blank'}
                rel="noopener noreferrer"
                href={facilityDetails.Website}
              >
                {facilityDetails.Website}
              </a>
            ) : (
              noDataMessage
            )}
          </p>
        </div>
      </div>
    </Col>
  );
};
export default LeftSection;
